<template>
  <div class="input-group mb-3 home-subscribe home-subscribe-ib">
    <b-form @submit="onSubmit">
      <b-input-group class="mt-3">
        <b-form-input
            class="form-control"
            v-model="form.email"
            type="email"
            placeholder="Your email"
        ></b-form-input>
        <div class="input-group-append">
          <b-button class="btn" type="submit" variant="primary">Get Started</b-button>
        </div>
      </b-input-group>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'GetStarted',
  data()
  {
    return {
      form: {
        email: ''
      }
    }
  },
  created()
  {
    this.form.email = this.$store.getters.email
  },
  methods: {
    onSubmit(evt)
    {
      evt.preventDefault()
      if (this.form.email)
      {
        this.$store.dispatch('updateEmail', this.form.email)
      }
      this.$router.push('/register')
    }
  }
}
</script>

<style lang="scss" scoped>
.home-subscribe-ib{
  display: inline-block;
}

.home-subscribe {
  max-width: 420px;
  text-align: center;
  margin: 24px auto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;

  .form-control {
    background: #FFFFFF;
    border: 2px solid #DFE1E6;
    box-sizing: border-box;
    border-radius: 24px 0 0 24px;
    height: 48px;
  }

  .btn {
    background: #30A7FE;
    border-radius: 0 24px 24px 0;
    color: #FFFFFF;
  }
}

@media only screen and (max-width: 585px) {
  form, .mt-3 {
    width: 100% !important;
  }
}
</style>
